import {DisconnectedNodes, MapNode} from 'common/src/modules/nodes/nodes.types';
import toDisconnectedMapNode from './toDisconnectedMapNode';

/**
 * Creates a disconnected map nodes list from a list of connected map nodes.
 * @param nodes - The list of connected map nodes to convert.
 * @returns The disconnected map nodes list.
 */
export default function createDisconnectedMapNodesList(nodes: MapNode[]): DisconnectedNodes {
  return nodes.reduce((acc, node) => {
    acc[node.id] = toDisconnectedMapNode(node);

    return acc;
  }, {} as DisconnectedNodes);
}
